import { Image } from "@chakra-ui/react";
import React from "react";

interface Props {
  src: string;
}

export const VersionHeader = React.memo(({ src }: Props) => {
  return (
    <Image paddingX={{ base: 2, sm: 4 }} src={src} maxW="500px" w="100%" />
  );
});
